import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EjendommeService } from 'src/app/api/services';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';
import { Sted } from '../../../api/models';
import { NotificationService } from '../../notifications/notification.service';
import { TekstResourcePipe } from '../../pipes/tekstresource.pipe';
import { Focusable } from '../../services/autofocus/focusable';

declare const adressevaelger: {
  adressevaelger: (
    inputElement: HTMLElement,
    options: {
      select: (selected: any) => void;
      maksimum: number;
      medtagForeloebige: boolean;
      token: string;
    }
  ) => unknown;
};

@Component({
  selector: 'bom-address-input',
  templateUrl: './address-input.component.html',
  styleUrls: ['./address-input.component.scss'],
})
export class AddressInputComponent implements OnInit, OnDestroy, Focusable {
  @Output()
  searchSted = new EventEmitter<Sted>();
  @Output()
  searchButtonToggle = new EventEmitter<boolean>();
  @Output()
  valgtStedLoadingToggle = new EventEmitter<boolean>();
  @Input()
  searchClicked: Observable<any>;
  @Input()
  disabled = false;

  @ViewChild('input', { static: true })
  input: ElementRef;

  searchSubscription: Subscription;
  addressResponse: Sted;

  private appConfig: AppConfig;

  constructor(
    private ejendommeService: EjendommeService,
    private notificationService: NotificationService,
    private tekstResourcePipe: TekstResourcePipe,
    appConfigService: AppConfigService
  ) {
    this.appConfig = appConfigService.getConfig();
  }

  ngOnInit() {
    this.searchSubscription = this.searchClicked.subscribe(() => {
      this.fireStedSearch();
    });

    adressevaelger.adressevaelger(this.input.nativeElement, {
      select: (selected: any) => {
        this.valgtStedLoadingToggle.emit(true);
        this.searchButtonToggle.emit(true);
        this.ejendommeService
          .getEjendomsStedByAdresseId(selected.adresse.id_lokalid)
          .pipe(
            finalize(() => {
              this.valgtStedLoadingToggle.emit(false);
            })
          )
          .subscribe(addressResponse => {
            if (addressResponse.externalCallSuccess) {
              this.addressResponse = addressResponse.ejendom;
              this.fireStedSearch();
            } else {
              this.notificationService.warn(
                this.tekstResourcePipe.transform('Fejl.Notifikation.EksternSystem.Error'),
                null,
                addressResponse.correlationId
              );
            }
          });
      },
      maksimum: 20,
      medtagForeloebige: true,
      token: this.appConfig.adressevaelgerToken,
    });
  }

  fireStedSearch() {
    this.searchSted.emit(this.addressResponse);
  }

  setFocus() {
    this.input.nativeElement.focus({ preventScroll: true });
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
}
